import HeaderTitle from '../../../../../common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import { cn } from '../../../../../common-utils/libraries/tailwind/utils';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '../../../../../common-utils/components/ui/modal';
import FooterForm from '../../../../../common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import Entity from '../../../../../common-utils/components/renders/entity/Entity';
import { useState } from 'react';
import actionsPushPayments from '../../api/actionsPushPayments';
import { toast } from '@/common-utils/hooks/use-toast';
import { nsNotifRules } from '@/app/i18n/namespaces';
import PropTypes from 'prop-types';

/**
 * @param {JSX.Element} trigger element that triggers modal opening
 * @returns {JSX.Element} ModalRemoveNotifRule Component
 */
function ModalRemoveNotifRule({ trigger, isOpen, setIsOpen, pushPaymentNotifRuleId, setLaunchRefetch }) {

    const [showSubmitButton, setShowSubmitButton] = useState(true);

    // API Calls
    const onSuccess = () => {
        setShowSubmitButton(false);
        setIsOpen(false);
        setLaunchRefetch(true);
        toast({
            description: <Entity entity='modal.delete.success' namespace={nsNotifRules} />,
            variant: 'success'
        });
    };
    const onError = () => {
        setShowSubmitButton(false);
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.delete.error' namespace={nsNotifRules} />,
            variant: 'danger'
        });
    };
    const deleteRule = actionsPushPayments.removeNotifRule(onSuccess, onError);

    const onClose = () => {
        setIsOpen(false);
        if (deleteRule.isSuccess) {
            setLaunchRefetch(true);
        }
    };

    // Renders
    const content =
        <ModalContent className={cn('max-w-lg')}>
            <HeaderTitle title={'modal.delete.title'} namespace={nsNotifRules} />
            <ModalBody>
                <div className='flex flex-col items-center gap-y-4'>
                    <Entity entity={'modal.delete.text'} namespace={nsNotifRules} />
                    <Entity entity={'modal.delete.warning'} namespace={nsNotifRules} />
                </div>
            </ModalBody>
            <FooterForm
                onSubmit={() => deleteRule.mutate(pushPaymentNotifRuleId)}
                isSubmitting={deleteRule.isLoading}
                showSubmitButton={showSubmitButton}
            />
        </ModalContent>;

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={onClose}>
            {content}
        </Modal>
    );
}

ModalRemoveNotifRule.propTypes = {
    trigger: PropTypes.node,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
    pushPaymentNotifRuleId: PropTypes.string,
    setLaunchRefetch: PropTypes.func
};

export default ModalRemoveNotifRule;